import { Component, HostListener } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import * as moment from "moment";
import { environment } from "../environments/environment";
import { AuthService } from "./service/auth/auth.service";
import { CommonService } from "./service/common/common.service";
import { GtmService } from "./service/gtm/gtm.service";
import { HttpService } from "./service/http/http.service";
import { MemberService } from "./service/member/member.service";
import { ShareService } from "./service/share/share.service";


moment.locale("ko");

declare var Kakao: any;
declare var ga: any;

@Component({
  selector: "app-root",
  styleUrls: ["app.component.scss"],
  templateUrl: "./app.component.html",
})
export class AppComponent {
  english: boolean = false;
  loaded: boolean = false;

  memberPath: boolean = false;
  isApp: boolean = false;
  isLogin: boolean = false;
  isMobile: boolean = false;

  // Modal: issue-210510
  thirdPartyModalEvent;
  policyModal = {
    showPrivacy: false,
    showThirdParty: false,
  };

  get showDimmend() {
    return this.policyModal.showPrivacy || this.policyModal.showThirdParty;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private httpService: HttpService,
    private memberService: MemberService,
    private shareService: ShareService,
    private authService: AuthService,
    private commonService: CommonService,
    private gtmService: GtmService
  ) {
    this.english = environment.english;

    this.router.events.subscribe(async (evt: any) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      if (this.authService.isExpiredRefreshToken()) {
        this.authService.removeToken();
      }

      if (authService.canActivate()) {
        const me = await this.httpService
          .get(`/api/members/me`)
          .toPromise()
          .then((data) => data.json());
        const processStep = authService.getPolicyStep();

        // 정보 미기입 신규유저는 signup page로 이동
        if (
          !AuthService.isValid(me) &&
          moment(me.createdDate, "YYYY-MM-DD").isSameOrAfter(
            moment("2021-05-15T00:00:00")
          )
        ) {
          this.router.navigateByUrl("/signup");
          return;
        }

        // 로그인 상태에서 5월 10일 00:00을 넘긴 경우
        if (
          processStep !== "end" &&
          moment().isSameOrAfter(moment("2021-05-10T00:00:00"))
        ) {
          // 처음인 경우 로그아웃 처리
          if (!processStep) {
            this.router.navigateByUrl("/");
            this.httpService.logout();
            authService.setPolicyStep("logout");
            return;
          }
          // 지점별 정책 모달 오픈
          else if (processStep === "logout") {
            const policy = await memberService.getPolicy();

            // 개인정보처리(공통, 필수)
            this.policyModal.showPrivacy = !policy.privacyPolicy;

            // 개인정보3자제공(서울숲, 선택), 개인정보처리 이력이 없으면 해당 모델 호출
            if (me.location.key === "seoulsoop" && !policy.privacyPolicyDate) {
              this.policyModal.showThirdParty = !policy.thirdParty;
            }
          }
        }
        // 개인정보처리는 했지만 필수 정보를 기입하지 않은 유저 myinfo-edit으로 이동
        else if (processStep === "end" && !AuthService.isValid(me)) {
          this.router.navigateByUrl("/member/myinfo-edit");
          return;
        }
      }

      this.memberPath = evt.urlAfterRedirects.startsWith("/member/");
      this.isLogin = evt.urlAfterRedirects.startsWith("/login");

      if (!this.loaded && this.memberPath) {
        this.loaded = true;
        this.authService.setRedirect(evt.urlAfterRedirects);
      } else if (evt.urlAfterRedirects != "/login") {
        // this.authService.setRedirect(null);
        this.authService.setRedirect(evt.urlAfterRedirects);
      }

      this.gtmService.pageView(evt.url);

      if (this.memberPath) {
        this.shareService.refreshCredit();
        this.shareService.refreshPrint();
      }
    });

    this.thirdPartyModalEvent = commonService.thirdPartyModalEvent.subscribe(
      () => (this.policyModal.showThirdParty = true)
    );
  }

  ngOnInit() {
    Kakao.init("ad5c97691303a192e8f570a8f02204d7");

    this.isMobile = window.innerWidth < 768;
    this.isApp = window.navigator.userAgent.indexOf("hey_application") > -1;
  }

  ngOnDestroy() {
    this.thirdPartyModalEvent.unsubscribe();
  }

  @HostListener("window:resize", ["$event"]) onResize(event) {
    let isMobile = event.target.innerWidth < 768;
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts